import PropTypes from 'prop-types';
import React from 'react';
import { LinkButton, DefaultButton } from '../utils/Styled/buttons';
import cx from 'classnames';
import Style from './style.scss';
import { Grid, Modal } from 'react-bootstrap';
import FilterItem from './filterItem';
import CategoryFilterItem from './categoryFilterItem';
import StyledIconWrapper from '../utils/Styled/blankIconWrapper';
import { StyledModal } from '../utils/Styled/modal';
import C from '../../constants/scoreBoard';

class ScoreboardFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      filterSelected: {},
      filterOptions: []
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.cancel = this.cancel.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.submit = this.submit.bind(this);
  }

  handleClick() {
    this.setState({ show: !this.state.show }, () => {
      if (this.state.show) {
        return this.props.initAction().then(result => {
          let filterSelected = { ...this.props.filterSelectedPrev };
          this.setState(...this.state, {
            filterOptions: result,
            filterSelected: filterSelected
          });
        });
      }
    });
  }

  closePopup() {
    this.cancel();
    this.setState({ show: false });
  }

  cancel() {
    let filterSelected = { ...this.props.filterSelectedPrev };
    this.setState(...this.state, { filterSelected: filterSelected });
  }

  handleSelectChange(listId, value) {
    let filterSelected = this.state.filterSelected;
    switch (listId) {
      case C.CATEGORY_TYPE.FIRST:
        filterSelected[C.CATEGORY_TYPE.SECOND] = [];
        filterSelected[C.CATEGORY_TYPE.THIRD] = [];
        break;
      case C.CATEGORY_TYPE.SECOND:
        filterSelected[C.CATEGORY_TYPE.THIRD] = [];
        break;
    }
    filterSelected[listId] = value;
    this.setState(...this.state, { filterSelected: filterSelected });
  }

  clearAll() {
    let filterSelected = this.state.filterSelected;
    Object.keys(this.state.filterSelected).forEach(key => {
      filterSelected[key] = [];
    });
    this.setState(...this.state, { filterSelected: filterSelected });
  }

  submit() {
    this.setState({ show: false });
    let filterSelected = this.state.filterSelected;
    let usedFilters = Object.keys(filterSelected).join(',');
    let filterCount = this.state.filterOptions.length;
    this.props.submitAction(filterSelected, usedFilters, filterCount);
  }

  render() {
    let categoriesFilters = [];
    let filters = [];
    this.state.filterOptions.forEach(p => {
      if (p.id === C.CATEGORY_TYPE.FIRST) {
        categoriesFilters.push(
          <CategoryFilterItem
            intlObject={this.props.intlObject}
            key={p.id}
            id={p.id}
            options={p.values}
            label={p.caption}
            value={this.state.filterSelected[p.id]}
            onChange={this.handleSelectChange}
          />
        );
        if (
          p.secondId &&
          this.state.filterSelected[p.id] &&
          this.state.filterSelected[p.id].length > 0 &&
          this.state.filterSelected[p.id][0] &&
          this.state.filterSelected[p.id][0].values
        ) {
          categoriesFilters.push(
            <CategoryFilterItem
              intlObject={this.props.intlObject}
              key={p.secondId}
              id={p.secondId}
              options={this.state.filterSelected[p.id][0].values}
              label={p.secondCaptions}
              value={this.state.filterSelected[p.secondId]}
              onChange={this.handleSelectChange}
            />
          );
          if (
            p.thirdId &&
            this.state.filterSelected[p.secondId] &&
            this.state.filterSelected[p.secondId].length > 0 &&
            this.state.filterSelected[p.secondId][0] &&
            this.state.filterSelected[p.secondId][0].values
          ) {
            categoriesFilters.push(
              <CategoryFilterItem
                intlObject={this.props.intlObject}
                key={p.thirdId}
                id={p.thirdId}
                options={this.state.filterSelected[p.secondId][0].values}
                label={p.thirdCaption}
                value={this.state.filterSelected[p.thirdId]}
                onChange={this.handleSelectChange}
              />
            );
          }
        }
        filters.push(categoriesFilters);
      } else {
        filters.push(
          <FilterItem
            intlObject={this.props.intlObject}
            id={p.id}
            key={p.id}
            options={p.values}
            label={p.caption}
            value={this.state.filterSelected[p.id]}
            onChange={this.handleSelectChange}
            asyncOption={this.props.asyncOption}
          />
        );
      }
    });
    // filters.push(regularFilters);
    filters = filters.reduce((acc, val) => acc.concat(val), []);

    //set isTop to open dropdown upwards from 3rd component to 2nd before last
    filters = filters.map((comp, index, array) =>
      React.cloneElement(comp, {
        isTop: index >= 2 && index + 3 > array.length
      })
    );

    const emptyComp = (
      <div className={cx(Style.emptyTabContent, 'topBottomMargin')}>
        <StyledIconWrapper>
          <span className={cx('iconIssue', Style.blankIcon, 'blankIcon')} />
        </StyledIconWrapper>
        <div>{this.props.intlObject['ssp.scoreboard.filter.disabled']}</div>
      </div>
    );
    let keysSelected = Object.keys(this.state.filterSelected);
    let clearAllBtnDisabled =
      keysSelected.length === 0 ||
      keysSelected.every(p => {
        return (
          !this.state.filterSelected[p] ||
          this.state.filterSelected[p].length === 0
        );
      });
    let footerBtnStyle =
      this.state.filterOptions.length === 0 ? { display: 'none' } : {};
    let activeClass = this.props.filterSelected.hint
      ? 'filterFull'
      : 'filterEmpty';
    return (
      <div className={Style.scoreboardFilterBtn}>
        <DefaultButton
          bsStyle="default"
          onClick={this.handleClick}
          title={this.props.hint}
        >
          {this.props.intlObject['ssp.scoreboard.filter']}
          <span className={cx('iconIssue', Style.buttonIcon, activeClass)} />
        </DefaultButton>
        <StyledModal
          dialogClassName="custom-modal"
          show={this.state.show}
          onHide={this.closePopup}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.intlObject['ssp.scoreboard.filter.list.filter']}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid className={cx(Style.scoreboardFilter, 'scoreboardFilter')}>
              <div
                className={cx(
                  Style.filtersContent,
                  filters.length > 3 ? Style.overflow : ''
                )}
              >
                <div className={Style.filterWrapper}>
                  {filters.length > 0 ? filters : emptyComp}
                </div>
              </div>
            </Grid>
          </Modal.Body>
          <Modal.Footer className={Style.scoreboardFilterFooter}>
            <LinkButton bsStyle="link" type="button" onClick={this.closePopup}>
              {' '}
              {this.props.intlObject['ssp.scoreboard.cancel']}
            </LinkButton>
            <DefaultButton
              bsStyle="default"
              style={footerBtnStyle}
              type="submit"
              onClick={this.submit}
            >
              {' '}
              {this.props.intlObject['ssp.scoreboard.apply']}
            </DefaultButton>
            <LinkButton
              bsStyle="link"
              style={footerBtnStyle}
              className={Style.clearAllBtn}
              type="button"
              disabled={clearAllBtnDisabled}
              onClick={this.clearAll}
            >
              {' '}
              {this.props.intlObject['ssp.scoreboard.clear.all']}
            </LinkButton>
          </Modal.Footer>
        </StyledModal>
      </div>
    );
  }
}

ScoreboardFilter.propTypes = {
  intlObject: PropTypes.object.isRequired,
  initAction: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
  filterSelected: PropTypes.object,
  filterSelectedPrev: PropTypes.object,
  asyncOption: PropTypes.func,
  hint: PropTypes.string
};

export default ScoreboardFilter;



// WEBPACK FOOTER //
// ./components/Scoreboard/scoreboardFilter.js